export {default} from './Persona';
export * from './types';



// WEBPACK FOOTER //
// ./src/components/Persona/index.ts